import { CardioOrResistance } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import BagContactGlove from '../../assets/images/bag-contact-glove.svg';
import BagContactHand from '../../assets/images/hand-gasture.svg';
import Theme, { ThemeType } from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { themeStyleMapper } from '../steps/personaliseWorkoutSteps';
import { ButtonMargin, SelectionContainer } from './SelectionContainer';

interface IProps {
  allowBagContactSetting: boolean;
  theme: ThemeType;
  t(key: string): string;
  onPress(workoutType: CardioOrResistance): Promise<void>;
}

export const AllowBagContactSelection: FunctionComponent<IProps> = ({
  t, onPress, theme = ThemeType.light, allowBagContactSetting,
}) => {
  const themeStyle = themeStyleMapper[theme];
  return (
    <View style={styles.container}>
      <BagContactType
        style={{ marginRight: ButtonMargin }}
        onPress={onPress}
        allowBagContact={false}
        theme={theme}
        isSelected={!allowBagContactSetting}
        title={t('no')}
        settingIcon={(
          <BagContactHand
            stroke={!allowBagContactSetting ? themeStyle.themeColor1Inverse : themeStyle.themeColor1}
            strokeWidth={1.7}
            width={defaultScale(32)}
            height={defaultScale(32)}
          />
)}
      />
      <BagContactType
        onPress={onPress}
        style={{ marginLeft: ButtonMargin }}
        allowBagContact
        theme={theme}
        isSelected={allowBagContactSetting}
        title={t('yes')}
        settingIcon={(
          <BagContactGlove
            stroke={allowBagContactSetting ? themeStyle.themeColor1Inverse : themeStyle.themeColor1}
            strokeWidth={1.7}
            width={defaultScale(32)}
            height={defaultScale(32)}
          />
)}
      />
    </View>
  );
};

function BagContactType({
  allowBagContact, onPress, style, theme, settingIcon, isSelected, title,
}) {
  const themeStyle = themeStyleMapper[theme];
  return (
    <View>
      <SelectionContainer
        width={defaultScale(110)}
        height={defaultScale(110)}
        title={title}
        titleStyle={[styles.title, { color: isSelected ? themeStyle.themeColor1Inverse : themeStyle.themeColor1 }]}
        isSelected={isSelected}
        style={style}
        onPress={() => onPress(allowBagContact)}
        theme={theme}
        icon={settingIcon}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: defaultScale(10),
  },
  title: {
    ...Theme.textStyle.bodyCopyBold,
    paddingTop: defaultScale(10),
    textAlign: 'center',
  },
});
